<template>
  <div class="setting">
    <p>
      订阅标签数量限制
      <el-tooltip
        class="item"
        effect="dark"
        content="订阅标签数量，开通会员可以获得更多订阅标签"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
      ：{{ tagLimit }}
    </p>
    <div class="narrowContainer">
      <SubscribeTags></SubscribeTags>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SubscribeTags from "../components/SubscribeTags.vue";

export default {
  data() {
    return {
      passwordData: {
        current_password: "",
        password: "",
        password_confirmation: ""
      },
      tags: [],
      tagLimit: 3,
      allTags: [],
      updated: false
    };
  },
  computed: {
    ...mapState(["user"])
  },
  components: {
    SubscribeTags
  },
  mounted: function() {
    this.fetchTagLimit();
  },
  methods: {
    ...mapMutations(["setLoading"]),
    fetchTagLimit() {
      this.tagLimit = "";
      this.$http
        .get("/user/tag-limit")
        .then(res => (this.tagLimit = res.data))
        .catch(() => (this.tagLimit = 3));
    }
  }
};
</script>
<style>
.setting {
  width: 70%;
}
</style>
